import { register } from '../../../JavaScript/Utils'

const CookieConsentToggler = el => {
  el.addEventListener('click', () => {
    const hsp = window._hsp = window._hsp || []
    hsp.push(['showBanner'])
  })
}

register('CookieConsentToggler', CookieConsentToggler)
